import { createAction, props } from '@ngrx/store';
import { ListResponse } from '@viewbid/ts-angular-client';

// eslint-disable-next-line
export const loadUserBidHistory = createAction(
    '[UserBidHistory] User Bid History',
    props<{
        page: number;
        pageSize: number;
        query: string;
        orderBy?: string;
    }>(),
);

// eslint-disable-next-line
export const loadUserBidHistorySuccess = createAction(
    '[UserBidHistory] Load User Bid History Success',
    props<{ response: ListResponse }>(),
);

// eslint-disable-next-line
export const loadUserBidHistoryFailure = createAction(
    '[UserBidHistory] Load User Bid History Failure',
    props<{ error: Error }>(),
);
